import React from 'react';
import { TFunction } from 'i18next';
import { MenuItemType } from '../../../../ui';
import { PencilIcon, TrashIcon } from '../../../../ui/icons/icons';
import { ADMIN_PAGES_KEYS } from '../../../../i18n/constants/keys';
import { Permission } from '../../../../utils/helpers/permissions';
import { EmployeeUser } from '../../../../utils/types/admin_types';

interface IMenuItemsColumns {
  onEdit: (row: EmployeeUser) => void;
  onDelete: (row: EmployeeUser) => void;
  t: TFunction;
}

export const getMenuItemsForMenu = ({
  onEdit,
  onDelete,
  t,
}: IMenuItemsColumns): MenuItemType<EmployeeUser>[] => {
  const EM = ADMIN_PAGES_KEYS.employeeManagement;
  const menuItems: MenuItemType<EmployeeUser>[] = [
    {
      label: t(EM.contextMenu.update),
      icon: <PencilIcon />,
      permission: [Permission.USERS_EDIT],
      onClick: (row) => onEdit(row),
    },
    {
      label: t(EM.contextMenu.deleteItem),
      icon: <TrashIcon />,
      permission: [Permission.USERS_DELETE],
      onClick: (row) => onDelete(row),
    },
  ];
  return menuItems;
};
